import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { getTeamMemberListData, _getTMDataById } from '../teamMembers/mockData'
import type { ISplit } from '~/types/teamMember/models'
import type { TEntityId } from '~/types/models'

const splitListData = undefined as unknown as ISplit[]

export const getSplitListData = getListDataFunctionFactory<ISplit[]>({
  listData: splitListData,
  storageKey: 'splits',
  getStartingListData: getStartingSplitListData,
})

export async function getSplitDataById(id: TEntityId): Promise<ISplit> {
  const list = await getSplitListData()
  if (!list) {
    throw new Error(`getSplitList returned undefined/null`)
  }
  const split = list.find((p: ISplit) => p.id === id)
  if (!split) {
    throw new Error(`Can't find contact '${id}'`)
  }
  return split
}

export async function getSplitListDataByTeamMemberId(id: string) {
  const list = await getSplitListData()
  if (!list) {
    throw new Error(`getSplitList returned undefined/null`)
  }
  return (
    list.filter(
      (split: ISplit) => !!split.teamMember && isEqual(split.teamMember.id, id)
    ) ?? []
  )
}

export async function getStartingSplitListData(): Promise<ISplit[]> {
  const tmList = await getTeamMemberListData()
  return [
    {
      // Meryl Streep
      id: 'XXPO0001',
      hrid: 'PO0001',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'SPIFF',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0002',
      hrid: 'PO0002',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'SPIFF',
      fraction: 0.3,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0003',
      hrid: 'PO0003',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0004',
      hrid: 'PO0004',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Consulting',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0005',
      hrid: 'PO0005',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'Commission',
      fraction: 0.1,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Consulting',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0006',
      hrid: 'PO0006',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'XXO00003',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0007',
      hrid: 'PO0007',
      teamMember: _getTMDataById('XXTM0001', tmList),
      splitType: 'Commission',
      fraction: 0.3,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    // Robert Downy, Jr
    {
      id: 'XXPO0001',
      hrid: 'PO0001',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'SPIFF',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0002',
      hrid: 'PO0002',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'SPIFF',
      fraction: 0.3,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0003',
      hrid: 'PO0003',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0004',
      hrid: 'PO0004',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Consulting',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Anthony Hopkins',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0005',
      hrid: 'PO0005',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'Commission',
      fraction: 0.1,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Consulting',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0006',
      hrid: 'PO0006',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'Commission',
      fraction: 0.05,
      company: 'Any',
      opportunity: 'XXO00003',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXPO0007',
      hrid: 'PO0007',
      teamMember: _getTMDataById('XXTM0005', tmList),
      splitType: 'Commission',
      fraction: 0.3,
      company: 'Any',
      opportunity: 'Any',
      leadSource: 'Any',
      supplier: 'Any',
      product: 'Any',
      tsd: 'Any',
      subAgent: 'Any',
      salesRep: 'Any',
      isActive: true,
      version: '1',
      canBeDeleted: false,
    },
  ]
}
